import { subscriptionRepository } from '../repositories/subscription-repository';

async function getSubscriptionStatus(subscriptionId) {
    if (!subscriptionId) {
        throw Error('Invalid parameters');
    }

    return subscriptionRepository.getStatus(subscriptionId);
}

export {
    getSubscriptionStatus
};
